import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";

const Footer = () => {
  const companyLinks = [
    { label: "About Us", href: "/about" },
    { label: "Partners", href: "/partners" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <footer className="footer">
      <div className="footer__glow footer__glow--left" />
      <div className="footer__glow footer__glow--right" />

      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__brand-badge">Future-ready IT solutions</div>
            <h2 className="footer__title">Build smarter, scale faster, stay secure.</h2>
            <p className="footer__text">
              We help businesses modernize infrastructure, strengthen security,
              and unlock growth with reliable technology services.
            </p>

            <div className="footer__socials">
              <a href="/" aria-label="Facebook" className="footer__social">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.7-1.6H16.7V4.8c-.3 0-1.4-.1-2.6-.1-2.6 0-4.3 1.6-4.3 4.5V11H7v3h2.8v8h3.7z" />
                </svg>
              </a>

              <a href="/" aria-label="LinkedIn" className="footer__social">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.94 8.5A1.94 1.94 0 1 1 6.94 4.62a1.94 1.94 0 0 1 0 3.88zM5.2 9.98h3.48V20.5H5.2zM10.86 9.98h3.34v1.44h.05c.46-.88 1.6-1.8 3.3-1.8 3.53 0 4.18 2.18 4.18 5.01v5.87h-3.48v-5.2c0-1.24-.02-2.84-1.82-2.84-1.82 0-2.1 1.34-2.1 2.74v5.3h-3.47z" />
                </svg>
              </a>

              <a href="/" aria-label="Twitter" className="footer__social">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22 5.92c-.74.32-1.53.54-2.36.64a4.07 4.07 0 0 0 1.8-2.24 8.2 8.2 0 0 1-2.6.96A4.12 4.12 0 0 0 12 8.18c0 .32.03.64.1.94A11.66 11.66 0 0 1 3.6 4.8a4 4 0 0 0-.56 2.06c0 1.42.74 2.67 1.86 3.4a4.15 4.15 0 0 1-1.87-.5v.05c0 1.98 1.46 3.64 3.4 4.02-.36.09-.74.14-1.13.14-.27 0-.54-.03-.8-.08.54 1.64 2.1 2.84 3.96 2.88A8.3 8.3 0 0 1 2 18.45 11.72 11.72 0 0 0 8.29 20c7.55 0 11.68-6.08 11.68-11.36 0-.17 0-.34-.02-.52A8.18 8.18 0 0 0 22 5.92z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer__side">
            <div className="footer__column">
              <h4>Company</h4>
              <ul>
                {companyLinks.map((item) => (
                  <li key={item.href}>
                    <Link to={item.href}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__contact-card">
              <h4>Let’s talk</h4>
              <p>
                Need help with your next project, managed services, or digital
                transformation plan?
              </p>
              <Link to="/contact" className="footer__cta">
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© 2026 Your Company. All rights reserved.</p>

          <div className="footer__bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
